import { useRef, useState } from "react";

export function usePointerEvents ( { onClick, onDoubleClick, onMouseHold } ) {
	const [ pointerState, setPointerState ] = useState ( "idle" );
	const timeoutRef                        = useRef ( null );
	const doubleClickTimeoutRef             = useRef ( null );
	const clickCountRef                     = useRef ( 0 );
	const isPointerHeldRef                  = useRef ( false );

	const handlePointerDown = () => {
		clickCountRef.current ++;
		setPointerState ( "pointerDown" );
		clearTimeout ( timeoutRef.current );

		timeoutRef.current = setTimeout ( () => {
			setPointerState ( "pointerHold" );
			onMouseHold ();
			isPointerHeldRef.current = true; // Mark as held
		}, 500 );
	};

	const handlePointerUp = () => {
		clearTimeout ( timeoutRef.current );
		clearTimeout ( doubleClickTimeoutRef.current );
		setPointerState ( "pointerUp" );

		if ( !isPointerHeldRef.current ) {
			doubleClickTimeoutRef.current = setTimeout ( () => {
				if ( clickCountRef.current === 1 ) {
					onClick ();
					setPointerState ( "singleClick" );
				}
				if ( clickCountRef.current === 2 ) {
					onDoubleClick ();
					setPointerState ( "doubleClick" );
				}
				clickCountRef.current = 0;
			}, 200 );
		}

		isPointerHeldRef.current = false; // Reset hold flag
	};

	// const handleDoubleClick = () => {
	// onDoubleClick ();
	// setPointerState ( "doubleClick" );
	// };

	return {
		pointerState,
		handlePointerDown,
		handlePointerUp
		// handleDoubleClick
	};
}

